import biopic from "../../images/biopic.png";
import "./about.css";

export default function About() {
  return (
    <div className="header">
      <h1>Hello! I'm Ivy</h1>
      <div className="bio-section">
        <div className="bio">
          <p>
            I’m an explorative & curious multidisciplinary designer focused on
            UI/UX and 3D currently based in Taipei, Taiwan. With UX/UI design,
            I’m hoping to work on interesting projects that bring people
            together. With 3D, I want to tell stories about narratives that are
            not often heard and amplify voices through beautiful
            stills/animations. I studied Cognitive Science + Human-Computer
            Interaction at University of California, Santa Cruz and graduated in
            2021. Some of my interests/hobbies include screen printing, tennis,
            and front-end development.
          </p>
          <p>
            My passion for design has been there since the beginning. As a
            child, I was into How It’s Made TV Show because I was so intrigued
            by the behind the scenes of how things are made. I grew up with a
            fine arts background, dabbling in various art medium through my high
            school's arts program. I'm drawn to design for its unique
            combination in aesthetics + functionality + impact. I studied
            cognitive science in college because was simulaneously also
            interested in neuroscience and thought theories/research could help
            imform the design of products. Today, I'm mesmerized by products
            with an emphasis on social impact and motion pieces that tells
            stories.
          </p>
        </div>
        <img className="profile-pic medium-img" src={biopic} alt="profile" />
      </div>
      <div className="section-title">Skills</div>
      <div className="tags">
        <div className="tag-about">
          <h3>Figma</h3>
        </div>
        <div className="tag-about">
          <h3>Adobe Illustrator</h3>
        </div>
        <div className="tag-about">
          <h3>Cinema4d</h3>
        </div>
        <div className="tag-about">
          <h3>Redshift</h3>
        </div>
        <div className="tag-about">
          <h3>Procreate</h3>
        </div>
        <div className="tag-about">
          <h3>After Effects</h3>
        </div>
        <div className="tag-about">
          <h3>Blender</h3>
        </div>
        <div className="tag-about">
          <h3>React JS</h3>
        </div>
        <div className="tag-about">
          <h3>Javascript</h3>
        </div>
      </div>
      <div className="section-title">Strengths + Interests</div>
      <div className="tags">
        <div className="tag-about">
          <h3>Writing</h3>
        </div>
        <div className="tag-about">
          <h3>Community</h3>
        </div>
        <div className="tag-about">
          <h3>Event Planning</h3>
        </div>
        <div className="tag-about">
          <h3>Climate Change</h3>
        </div>
        <div className="tag-about">
          <h3>Augmented Reality</h3>
        </div>
        <div className="tag-about">
          <h3>Social Impact</h3>
        </div>
      </div>
    </div>
  );
}
